import { simpleClient } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { Site } from '../entities';
import { Service } from './services';

export const client = simpleClient<Site>();
const endpointCreator = () => '/sites';

export const { Actions, Selectors, Sagas } = createService<Site, Service.Sites>({
  service: Service.Sites,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.clients.sites,
  sagas: ['GET', 'GET_COLLECTION', 'CREATE', 'UPDATE'],
  persistUpdates: true,
});
